export const BootstrapPhase = {
  Idle: 'idle',
  RestoringSession: 'restoring_session',
  Unauthenticated: 'unauthenticated',
  LoadingProfile: 'loading_profile',
  LoadingMemberships: 'loading_memberships',
  EvaluatingOnboarding: 'evaluating_onboarding',
  OnboardingRequired: 'onboarding_required',
  LoadingRole: 'loading_role',
  LoadingOrganization: 'loading_organization',
  Ready: 'ready',
  Error: 'error',
} as const;

export type BootstrapPhase = (typeof BootstrapPhase)[keyof typeof BootstrapPhase];

export interface AppState {
  bootstrapPhase: BootstrapPhase;
  bootstrapMessage: string | null;
  bootstrapError: string | null;
  isBootstrapping: boolean;
}
